export default __webpack_public_path__ + "static/illustration-content-rect.url-eacd7021d22f21277a3ae753847ab65e.svg";